"use client"

import { useEffect, useRef, useState } from "react"

export function RevealOnScroll({ children, className = "", animationClass = "animate-fade-in-blur" }: { children: React.ReactNode, className?: string, animationClass?: string }) {
    const ref = useRef<HTMLDivElement>(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true)
                    observer.disconnect()
                }
            },
            {
                threshold: 0.1, // Trigger when 10% of the element is visible
            }
        )

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => observer.disconnect()
    }, [])

    return (
        <div
            ref={ref}
            className={`transition-opacity duration-1000 ${isVisible ? `opacity-100 ${animationClass}` : "opacity-0"
                } ${className}`}
        >
            {children}
        </div>
    )
}
